var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconParameters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#25262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0991 10.2623C23.3851 9.89826 21.6151 9.89826 19.9011 10.2623L18.9161 13.1533C17.9371 13.5293 17.0221 14.0573 16.2071 14.7173L13.2111 14.1243C12.0391 15.4263 11.1531 16.9603 10.6121 18.6263L12.6231 20.9243C12.4591 21.9613 12.4591 23.0173 12.6231 24.0533L10.6121 26.3513C11.1531 28.0173 12.0391 29.5513 13.2111 30.8533L16.2071 30.2603C17.0221 30.9203 17.9371 31.4483 18.9161 31.8243L19.9011 34.7153C21.6151 35.0803 23.3851 35.0803 25.0991 34.7153L26.0841 31.8243C27.0631 31.4483 27.9781 30.9203 28.7931 30.2603L31.7891 30.8533C32.9611 29.5513 33.8471 28.0173 34.3881 26.3513L32.3771 24.0533C32.5411 23.0173 32.5411 21.9613 32.3771 20.9243L34.3881 18.6263C33.8471 16.9603 32.9611 15.4263 31.7891 14.1243L28.7931 14.7173C27.9781 14.0573 27.0631 13.5293 26.0841 13.1533L25.0991 10.2623ZM22.5001 18.7393C24.5701 18.7393 26.2501 20.4193 26.2501 22.4893C26.2501 24.5583 24.5701 26.2393 22.5001 26.2393C20.4301 26.2393 18.7501 24.5583 18.7501 22.4893C18.7501 20.4193 20.4301 18.7393 22.5001 18.7393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParameters);
export default __webpack_public_path__ + "static/media/icon_parameters.17e8ba0a69daced7ac2dcf5363c346be.svg";
export { ForwardRef as ReactComponent };